import { QueryClient } from '@tanstack/react-query';
import { isQflyError } from '@/shared/api/problem';

/**
 * TanStack Query client with Qfly defaults:
 * - 30s staleTime — feature modules opt into realtime via SSE/WebSocket
 * - retry only on transient errors (5xx / network); never on 4xx
 * - refetchOnWindowFocus disabled — noisy for CRM table views
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isQflyError(error) && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
